import React from 'react';
import { StyledPrimaryButton } from 'components/Buttons/styled-component';
import { CoreButtonProps } from 'components/Buttons/CoreButton';

export interface PrimaryButtonProps extends CoreButtonProps {}

const PrimaryButton: React.FC<PrimaryButtonProps> = (props): JSX.Element => {
  return (
    <StyledPrimaryButton
      id="primary-button-style"
      titleclass="primary-button-title"
      {...props}
    />
  );
};

export default PrimaryButton;
